import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import { Snackbar, Alert, Box } from '@mui/material';
import BreadCrumb from '../BaseLayout/BreadCrumb';
import { RegisterCompany } from '@mobilitystore/user-onboarding-interface';
import ConfirmModal from '../Shared/Utils/Modal/ConfirmModal';
import { logout } from '../../actions/LoginAction';
import Loader from '../Shared/Utils/Loader';
import AllYouNeed from './AllYouNeed';
import HomepageBanner from './HomepageBanner/homepageBanner';
import UniqueSection from './UniqueSection';
import idConstants from '../../data/idConstants';
import { getEnvironment } from '../../utils';
import * as Constants from '../../actions/configuration';
import { IMAGE_CDN } from '../../actions/configuration';
import HowItWorks from './HowItWorks';

const Landing = (props) => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [confirmationModalLoader, setConfirmationModalLoader] = useState(false);
  const reduxStore = useSelector((state) => state);
  const mismatchInDcsAndMsData =
    reduxStore?.CompanyDetailsReducer?.mismatchInDcsAndMsData;

  const howItWorksImage = `${IMAGE_CDN}how-it-works.svg`;
  const howItWorksHeader = i18next.t('HOME_PAGE.CUSTOMER_JOURNEY.HOW_IT_WORKS');
  const howItWorksOptions = [
    i18next.t('HOME_PAGE.CUSTOMER_JOURNEY.SEARCH_PRODUCT'),
    i18next.t('HOME_PAGE.CUSTOMER_JOURNEY.CHOOSE_PRODUCT'),
    i18next.t('HOME_PAGE.CUSTOMER_JOURNEY.SUBSCRIBE_USE')
  ];

  const dispatchRedux = useDispatch();

  const handleRegisterModalClose = () => {
    localStorage.removeItem('popUpOpen');
    localStorage.removeItem('newLogin');
  };

  const handleLogOutUser = () => {
    setOpenConfirmModal(false);
    setConfirmationModalLoader(true);
    dispatchRedux(logout());
  };

  useEffect(() => {
    if (mismatchInDcsAndMsData) {
      setSnackAlertFlag(true);
      setSnackAlertMsg('Mismatch occurred in Company details between DCS and MS');
      setSnackAlertSeverity('error');
    }
  }, [mismatchInDcsAndMsData]);

  const [snackAlertFlag, setSnackAlertFlag] = useState(false);
  const [snackAlertMsg, setSnackAlertMsg] = useState('');
  const [snackAlertSeverity, setSnackAlertSeverity] = useState('');

  return (
    <React.Fragment>
      <BreadCrumb landing={true} />
      <Box mt={-2}>
        <HomepageBanner productCategories={props.productCategories} />
      </Box>
      <AllYouNeed />
      <UniqueSection />
      <HowItWorks
        header={howItWorksHeader}
        subHeader={howItWorksOptions}
        image={howItWorksImage}
      />
      {localStorage.getItem(idConstants.tokens.aaaIdToken) &&
        localStorage.getItem('newLogin') && (
          <RegisterCompany
            language='en'
            clientToken={localStorage.getItem(idConstants.tokens.aaaIdToken)}
            environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
            successHandler={(response) => {
              dispatchRedux({
                type: 'UPDATE_PROFILE_STATUS',
                payload: response
              });
              response?.status && localStorage.removeItem('newLogin');
            }}
            cancelHandler={() => {
              handleRegisterModalClose();
            }}
            errorHandler={(error) => {
              if (error.message) {
                setSnackAlertFlag(true);
                setSnackAlertMsg(error.message);
                setSnackAlertSeverity('error');
              }
            }}
            role={Constants.AAA_CONFIG.BUYER_ROLE}
          />
        )}
      <Snackbar
        open={snackAlertFlag}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={6000}
        onClose={() => {
          setSnackAlertFlag(false);
        }}
      >
        <Alert severity={snackAlertSeverity}>{snackAlertMsg}</Alert>
      </Snackbar>
      {confirmationModalLoader && <Loader />}
      {openConfirmModal && (
        <ConfirmModal
          modalContent=''
          heading={userRoleUpdatedToSeller.message}
          category={'approve'}
          callback={handleLogOutUser}
          okOperation={handleLogOutUser}
          cancelBtn='disable'
          noCloseIcon
          {...props}
        />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (redux_state) => ({
  accessToken: redux_state.loginReducer.accessToken
});

export default connect(mapStateToProps, null)(Landing);
